import { Controller } from "@hotwired/stimulus"
import * as Turbo from "@hotwired/turbo"
import { Modal } from "bootstrap"
import { TempFormHelper } from "~/helpers/temp_form_helper"

export default class extends Controller {
  static targets = ["modal"]

  static get values() {
    return {
      companyListId: { type: String, default: "" },
      exportPath: { type: String, default: "/lead/companies/export" },
      exportLimit: Number,
      totalCount: Number,
      planName: String,
    }
  }

  submit() {
    // Show modal if export will be limited
    if (this.totalCountValue > this.exportLimitValue) {
      new Modal(this.modalTarget).show()
      return
    }
    this.confirmExport()
  }

  confirmExport() {
    TempFormHelper.create(this.exportPathValue, "post", (form) => {
      TempFormHelper.addHiddenInput(form, "company_list_id", this.companyListIdValue)
    }).submit() // requestSubmit does not trigger the download
  }

  upgrade(event) {
    event.preventDefault()
    const url = event.currentTarget.href
    const modal = Modal.getInstance(this.modalTarget)

    this.modalTarget.addEventListener(
      "hidden.bs.modal",
      () => {
        Turbo.visit(url, { frame: "checkout-modal" })
      },
      { once: true },
    )

    modal.hide()
  }
}
